import React from 'react';

import { PageBase } from '../../../dtos';

import { PageItemContainer } from './styles';

export type PageItemProps = React.AnchorHTMLAttributes<HTMLAnchorElement> & {
  page: PageBase;
};

export const PageItem: React.FC<PageItemProps> = ({ page, ...props }) => {
  return (
    <PageItemContainer href={page.url} {...props}>
      <span title={page.name}>{page.name}</span>
    </PageItemContainer>
  );
};
